/* ⚠️ GENERATED from app/services/creatorDash.ts by gen-twins.mjs — edit the TypeScript, not this. */
/* ═══════════════════════════════════════════════════════════════════════════
   📈 creatorDash.ts — how the creator dashboard turns the server's numbers
   (insightsRoutes.dashboard) into what a screen says. One rule for the phone
   and the browser, so "+12%" means the same thing on both.
   ═══════════════════════════════════════════════════════════════════════════ */

export const DASH_RANGES = [7, 28, 90];

/** This period against the last: { pct, dir } — `null` pct when there was nothing before. */
export function delta(cur, prev) {
  const c = Math.max(0, Number(cur) || 0);
  const p = Math.max(0, Number(prev) || 0);
  if (p === 0) return {
    pct: null,
    dir: c > 0 ? 'up' : 'flat'
  };
  const pct = Math.round((c - p) / p * 100);
  return {
    pct,
    dir: pct > 0 ? 'up' : pct < 0 ? 'down' : 'flat'
  };
}

/** 1234 → "1.2K", 2500000 → "2.5M". */
export function compact(n) {
  const v = Math.max(0, Number(n) || 0);
  if (v < 1000) return String(Math.round(v));
  if (v < 1e6) return `${(v / 1e3).toFixed(v < 1e4 ? 1 : 0).replace(/\.0$/, '')}K`;
  return `${(v / 1e6).toFixed(v < 1e7 ? 1 : 0).replace(/\.0$/, '')}M`;
}

/** Bars for a series: each value as a fraction of the tallest (0..1), never NaN. */
export function bars(series, field) {
  const vals = (series || []).map(d => Math.max(0, Number(d && d[field]) || 0));
  const top = Math.max(1, ...vals);
  return vals.map(v => v / top);
}

/** "9 AM" / "21:00" style is the screen's business; this is the hour range "9–10". */
export function hourRange(h) {
  if (h == null || !Number.isFinite(h)) return '';
  const a = (h % 24 + 24) % 24;
  return `${a}:00–${(a + 1) % 24}:00`;
}

/** The kinds in the order a creator reads them, with what they have. */
export function kindRows(byKind) {
  const order = ['video', 'photo', 'text', 'poll', 'link'];
  const b = byKind || {};
  return order.filter(k => b[k] && b[k].posts > 0).map(k => ({
    kind: k,
    posts: b[k].posts,
    avgViews: b[k].avgViews || 0,
    avgEngagement: b[k].avgEngagement || 0
  }));
}
